import { useEffect, useState } from "react";
import { ContractorGroupData } from "../../to-be-removed/LocalData/ContractorGroup/ContractorGroupData";
import { LocalData } from "../../to-be-removed/LocalData/General/LocalData";

export const useContractorGroups = () => {
  const [contractorGroups, setContractorGroups] = useState<ContractorGroupData[]>([]);

  useEffect(() => {
    const ids = LocalData.currentUser.contractorGroups.map((contractor) => contractor.id);
    const accessibleProperties = LocalData.currentUser.properties.filter((p) => p.checkForLandlordRoles(LocalData.currentUser));

    for (const property of accessibleProperties) {
      for (const contractor of property.contractors) {
        if (!ids.includes(contractor.id) && !contractor.deleted) {
          ids.push(contractor.id);
        }
      }
    }

    LocalData.contractorGroups.loadDocuments(ids, (contractors) => {
      setContractorGroups(contractors.filter((group) => group.loaded));
    });
  }, []);

  return { contractorGroups };
};

/**
 * Get all contractor groups that the current user has access to and load un-loaded groups
 */
export const getAllContractorGroups = (): Promise<ContractorGroupData[]> => {
  let contractors = LocalData.currentUser.contractorGroups;
  const accessibleProperties = LocalData.currentUser.properties.filter((p) => p.checkForLandlordRoles(LocalData.currentUser));

  for (const property of accessibleProperties) {
    for (const contractor of property.contractors) {
      if (!contractors.includes(contractor) && !contractor.deleted) {
        contractors.push(contractor);
      }
    }
  }

  return Promise.all(contractors.filter((c) => !c.loaded).map((c) => c.load())).then(() => contractors);
};
